import React from "react";
import { Dropdown } from "../../../../common/components/dropdown/Dropdown";
import { datePickerYearsType } from "../../../../common/types/search/search";

interface YearPickerProps {
	id: string;
	filterDate?: () => void;
	onChange: (year: string) => void;
	value: string;
	years: datePickerYearsType;
	criterionKey?: string;
	label?: string;
}

export const YearPicker = ({
	id,
	label,
	onChange,
	value,
	years,
}: YearPickerProps) => {
	const handleYearChange = (year) => onChange(year.toString());

	return (
		<>
			<Dropdown
				activeItem={value.toString()}
				dropdownKey={id}
				dropdownItems={years}
				dropdownToggle={value.toString()}
				label={label}
				onDropdownItemClick={handleYearChange}
				data-criterion
				scrollToView
				preselected={!!value}
			/>
		</>
	);
};
